import React from 'react';

class Home extends React.Component{
    render(){
        return <div className="homeLogo"> 
            <h1>
            CeleBase
            </h1>
        </div>;
    }
}

export {Home}


// WEBPACK FOOTER //
// ./src/js/components/home.jsx